import AppContext from "PFApp/app_context";
import { DocumentButtons } from "PFApp/components/document_buttons";
import FiltersBox from "PFApp/components/filters/filters_box";
import { SavedViewsContextProvider } from "PFApp/components/filters/saved_views_context/saved_views_context";
import SortBy from "PFApp/components/sort_by";
import { PageTarget } from "PFTypes/saved_filters";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import css from "./header.less";
import Post from "./post/post";
import TaylorFeed from "./taylor_feed";
import TxTabs from "./tx_tabs";

const Header = ({
  fetchActivities,
  fetchActivitiesDocs,
  tab,
  setTab,
  saveInterestedSkill,
  toggleFilters,
  showFilters,
  tasks,
  handleFilterChange,
  handleFiltersReplace,
  handleOrderChange,
  clearFilters,
  clearRefValue,
  postTask,
  filtersAreClear
}) => {
  const {
    store: { currentProfile }
  } = useContext(AppContext);
  const { t } = useTranslation("feed");

  const { meta, entries } = tasks;
  const { first_name, templates } = currentProfile;
  const postTemplate = templates.find(({ key }) => key === "post");
  const orderMeta = meta.order;

  const viewsKey = PageTarget.ActivityFeed;

  return (
    <div className={css.wrapper}>
      <div className={css.title}>
        <div className={css.titleWrapper}>
          <div className={css.name}>{`${t("hiName", { name: first_name })} `}&nbsp;</div>
          <div>{t("welcomeMessage")}</div>
        </div>
        {entries.length > 0 && <DocumentButtons generateDocument={fetchActivitiesDocs} />}
      </div>
      <TxTabs
        fetchActivities={fetchActivities}
        tab={tab}
        setTab={setTab}
        toggleFilters={toggleFilters}
        showFilters={showFilters}
        filtersAreClear={filtersAreClear}
      />
      <SavedViewsContextProvider viewsKey={viewsKey}>
        {showFilters && (
          <div style={{ position: "relative", zIndex: 20, marginTop: 0 }}>
            <FiltersBox
              blockedList={tab === "my_activities" ? ["task_contributor_id"] : []}
              meta={meta}
              handleFilterChange={handleFilterChange}
              handleFiltersChange={handleFiltersReplace}
              clearFilters={clearFilters}
              clearRefValue={clearRefValue}
              closeFilters={toggleFilters}
              filtersAreClear={filtersAreClear}
              style={{ marginBottom: 20, position: "absolute", width: "100%" }}
              viewsKey={viewsKey}
            />
          </div>
        )}
      </SavedViewsContextProvider>
      <div className={css.feedAndSortWrapper}>
        <TaylorFeed saveInterestedSkill={saveInterestedSkill} />

        {orderMeta && (
          <SortBy
            sort={orderMeta.value?.text}
            options={orderMeta.options.map((option) => ({
              id: option.text,
              displayElement: option.text,
              item: option
            }))}
            onSortChange={handleOrderChange}
            style={{ margin: "0 0 15px auto" }}
          />
        )}
      </div>
      {postTemplate && postTemplate.create_permitted && (
        <Post profile={currentProfile} postTask={postTask} fetchActivities={fetchActivities} tab={tab} />
      )}
    </div>
  );
};

Header.propTypes = {
  fetchActivities: PropTypes.func,
  fetchActivitiesDocs: PropTypes.func,
  saveInterestedSkill: PropTypes.func,
  toggleFilters: PropTypes.func,
  tab: PropTypes.string,
  setTab: PropTypes.func,
  tasks: PropTypes.object,
  showFilters: PropTypes.bool,
  handleFilterChange: PropTypes.func,
  handleFiltersReplace: PropTypes.func,
  handleOrderChange: PropTypes.func,
  clearFilters: PropTypes.func,
  clearRefValue: PropTypes.number,
  postTask: PropTypes.object,
  filtersAreClear: PropTypes.bool
};

export default Header;
